var __app_timeout = 100;

if (__opt_view_mode == "mobile") {
  __app_timeout = 100;
}

setTimeout(function () {
  console.log("custom-scripts start");

  function mapGetLocalStorageKeyPrefix() {
    let localStorageKeyPrefix = $(".custom-bundle-form-item.open-product").attr(
      "data-product-index"
    );
    if (!localStorageKeyPrefix) return "";
    return localStorageKeyPrefix + "-";
  }

  function _convertDDToDMS(coordinate) {
    var absolute = Math.abs(coordinate);
    var degrees = Math.floor(absolute);
    var minutesNotTruncated = (absolute - degrees) * 60;
    var minutes = Math.floor(minutesNotTruncated);
    var seconds = Math.round((minutesNotTruncated - minutes) * 60 * 100) / 100;
    if (coordinate < 0) degrees *= -1;
    return degrees + "°" + minutes + "'" + seconds.toFixed(2);
  }

  function convertDDToDMS(lat, lng) {
    lat = Number(String(lat).replace(/° \w/, ""));
    lng = Number(String(lng).replace(/° \w/, ""));
    var latitude = _convertDDToDMS(lat);
    var latitudeCardinal = lat > 0 ? '"N' : '"S';

    var longitude = _convertDDToDMS(lng);
    var longitudeCardinal = lng > 0 ? '"E' : '"W';

    return {
      latitude: latitude + latitudeCardinal,
      longtitude: longitude + longitudeCardinal,
    };
  }

  function _convertDMSToDD(degrees, minutes, seconds, direction) {
    let dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / 3600;

    if (direction == "S" || direction == "W") {
      dd = dd * -1;
    } // Don't do anything for N or E
    return dd.toFixed(4) + "° " + direction;
  }

  function convertDMSToDD(lat, lng) {
    let latParts = lat.match(/(\d+)°(\d+)'(\d+\.?\d*)\"(\w)/);
    let longParts = lng.match(/(\d+)°(\d+)'(\d+\.?\d*)\"(\w)/);
    let latitude = _convertDMSToDD(latParts[1], latParts[2], latParts[3], latParts[4]);
    let longtitude = _convertDMSToDD(longParts[1], longParts[2], longParts[3], longParts[4]);
    return {
      latitude: latitude,
      longtitude: longtitude,
    };
  }

  function updateCoordinateInputs(lat, lng) {
    if (lat > 0) {
      lat = parseFloat(lat).toFixed(4) + "° N";
    } else {
      lat = parseFloat(lat).toFixed(4) + "° S";
    }
    if (lng > 0) {
      lng = parseFloat(lng).toFixed(4) + "° E";
    } else {
      lng = parseFloat(lng).toFixed(4) + "° W";
    }

    let localStorageKeyPrefix = mapGetLocalStorageKeyPrefix();
    localStorage.setItem(localStorageKeyPrefix + "cuffCoordinatesLongitude", lng);
    localStorage.setItem(localStorageKeyPrefix + "cuffCoordinatesLatitude", lat);

    if ($(".open-product #dmstoggler").is(":checked")) {
      let dms = convertDDToDMS(lat, lng);
      lat = dms.latitude;
      lng = dms.longtitude;
    }
    if ($("body").hasClass("custom-bundle")) {
      $(".open-product #latitude").val(lat);
      $(".open-product #longtitude").val(lng);
    } else {
      document.getElementById("latitude").value = lat;
      document.getElementById("longtitude").value = lng;
    }
  }

  function localStorageGetLng() {
    let localStorageKeyPrefix = mapGetLocalStorageKeyPrefix();
    let lng = localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLongitude");
    if ($(".open-product #dmstoggler").is(":checked")) {
      lng = convertDDToDMS(0, lng).longtitude;
    }
    return lng;
  }

  function localStorageGetLat() {
    let localStorageKeyPrefix = mapGetLocalStorageKeyPrefix();
    let lat = localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLatitude");
    if ($(".open-product #dmstoggler").is(":checked")) {
      lat = convertDDToDMS(lat, 0).latitude;
    }
    return lat;
  }

  $(document).ready(function () {
    $(".landing_product_review_body").textfill({
      maxFontPixels: 36,
    });
    var text_max = $("#text-engrave").attr("maxlength");
    $(".text-engrave-remaining").html(text_max + " characters remaining");

    $("#text-engrave").keyup(function () {
      var text_length = $("#text-engrave").val().length;
      var text_remaining = text_max - text_length;

      $(".text-engrave-remaining").html(text_remaining + " characters remaining");
      if (text_remaining < 8) {
        $(".text-engrave-remaining").css("color", "orange");
      } else if (text_remaining == 0) {
        $(".text-engrave-remaining").css("color", "red");
      }
    });

    let defaultCoordinates = convertDMSToDD("-8°22'9.12\"S", "115°8'17.88\"E");
    localStorage.setItem("cuffCoordinatesLongitude", defaultCoordinates.longtitude);
    localStorage.setItem("cuffCoordinatesLatitude", defaultCoordinates.latitude);

    localStorage.setItem("1-cuffCoordinatesLongitude", defaultCoordinates.longtitude);
    localStorage.setItem("1-cuffCoordinatesLatitude", defaultCoordinates.latitude);

    // CUSTOM-BUNDLE SCRIPT BEGIN
    var customBundle = {
      // define a click handler
      openItem(item) {
        if (item.hasClass("open-product")) {
          return;
        }
        customBundle.closeOpenedItem();
        item.addClass("open-product");

        $(".open-product #latitude").attr("value", localStorageGetLat());
        $(".open-product #longtitude").attr("value", localStorageGetLng());
        $(".open-product").find("#search").prepend("<div id='geocoder'></div>");
        $(".open-product").find(".map-container").append("<div id='map'></div>");
        mapView();
      },

      closeOpenedItem() {
        $(".open-product").each(function () {
          customBundle.renderProperties($(this));
        });
        $(".open-product [id=map]").remove();
        $(".open-product [id=geocoder]").remove();
        $(".open-product").removeClass("open-product");
      },

      onItemClick(event) {
        event.stopPropagation();
        let isOpen = $(this).closest(".custom-bundle-form-item").hasClass("open-product");
        customBundle.closeOpenedItem();
        if (!isOpen) {
          customBundle.openItem($(this).closest(".custom-bundle-form-item"));
        }
      },

      addEventListeners(item) {
        item.find(".remove-icon").click(function (event) {
          if (item.closest(".custom-bundle-products-container").children().length != 1) {
            event.stopPropagation();

            item.remove();
            customBundle.updateCloneButtonText();
            $(".custom-bundle-form-item").each(function () {
              customBundle.applyDataAttributes($(this));
            });
          }
        });
        item.find(".bundle-save").click(function (event) {
          event.stopPropagation();
          customBundle.closeOpenedItem();
        });
        item.find(".bundle-form-item-label").click(customBundle.onItemClick);
        item.find("#text-engrave, #morse, #latitude, #longtitude").on("change", function () {
          customBundle.onItemChange(item);
        });
        item
          .find(
            ".ColorSwatchList .HorizontalList__Item, .SizeSwatchList .HorizontalList__Item, .engrave-font-chooser-item"
          )
          .click(function () {
            customBundle.onItemChange(item);
          });
      },

      onItemChange(item) {
        customBundle.updateStateCustomized(item);
      },

      updateStateCustomized(item) {
        let customized = customBundle.isItemFilled(item);
        customBundle.toggleStateCustomized(item, customized);
      },

      toggleStateCustomized(item, customized) {
        if (customized) {
          $(item).find(".custom-bundle-form-state").addClass("customized");
          $(item).find(".custom-bundle-form-state").html("Customized");
        } else {
          $(item).find(".custom-bundle-form-state").removeClass("customized");
          $(item).find(".custom-bundle-form-state").html("Choose color & engraving");
        }
      },

      renderProperties(item) {
        let propertiesContainer = item.find(".bundle-product-properties");

        function renderProperty(propType, value) {
          return (
            '<span class="bundle-properties-item prop-type--' +
            propType +
            '">' +
            propType +
            '<b> - <span class="prop-item-value">' +
            value +
            "</span></b></span>"
          );
        }

        function addFont() {
          var fontItem = item.find("#engraving-font");
          var bundlePropType = fontItem.attr("name").match(/\[(.*)\]/)[1],
            bundlePropValue = fontItem.val();
          propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
        }

        function addCoordinates() {
          item
            .find(".coordinates-variant")
            .find(".line-item-property__field")
            .each(function () {
              var bundlePropType = $(this)
                  .find("input")
                  .attr("name")
                  .match(/\[(.*)\]/)[1],
                bundlePropValue = $(this).find("input").val();
              propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
            });
        }

        function addText() {
          var _this = item.find(".engrave-text-cont").find(".line-item-property__field");
          _this.each(function () {
            if (item.find(".engrave-text-cont").hasClass("text-input-limit")) {
              var bundlePropType = _this
                  .find("textarea")
                  .attr("name")
                  .match(/\[(.*)\]/)[1],
                bundlePropValue = _this.find("textarea").val();
              propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
            } else {
              console.log("test");
              let inputName = $(this).find("input").attr("name");
              if (inputName) {
                var bundlePropType = inputName.match(/\[(.*)\]/)[1],
                  bundlePropValue = $(this).find("input").val();
                propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
              }
            }
          });
        }

        function addMorse() {
          var _this = item.find(".morse-variant").find(".line-item-property__field");
          var bundlePropType = _this
              .find("input")
              .attr("name")
              .match(/\[(.*)\]/)[1],
            bundlePropValue = _this.find("input").val();
          propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
        }

        function addColor() {
          //setTimeout(function () {
          var colorName = item
            .find('[data-option-name="COLOR"] .ProductForm__SelectedValue')
            .html();
          console.log("addColor", colorName);
          var bundlePropType = "Color",
            bundlePropValue = colorName;
          propertiesContainer.append(renderProperty(bundlePropType, bundlePropValue));
          //}, 100)
        }

        propertiesContainer.empty();
        if (item.find(".coords-btn").hasClass("active-switcher")) {
          console.log("coords active");
          addCoordinates();
          addFont();
          addColor();
        } else if (item.find(".text-btn").hasClass("active-switcher")) {
          console.log("text active");
          addText();
          addFont();
          addColor();
        } else if (item.find(".morse-btn").hasClass("active-switcher")) {
          console.log("morse active");
          addMorse();
          addColor();
        }
      },

      isItemFilled(item) {
        return (
          item.find("#text-engrave").val() ||
          item.find("#morse").val() ||
          (item.find("#latitude").val() && item.find("#longtitude").val())
        );
      },

      isInitialSearchReady(item) {
        return item.attr("data-initial-search-ready") !== undefined;
      },

      markInitialSearchReady(item, ready) {
        if (ready) {
          item.attr("data-initial-search-ready", "");
        } else {
          item.removeAttr("data-initial-search-ready");
        }
      },

      // define a helper function to set some data attributes, so the color swatches have unique IDs
      applyDataAttributes(item) {
        let bundleProductId = item.attr("data-product-id");
        let productIndex = $(".custom-bundle-products-container")
          .children(".custom-bundle-form-item")
          .index(item);
        let productNumber = productIndex + 1;
        item
          .find("#product-select-" + bundleProductId)
          .attr("id", "#product-select-" + bundleProductId + "-" + productNumber);
        item.attr("data-product-index", productNumber);
        item.find(".bundle-form-item-label .bundle-item-index").empty().html(productNumber);
        let productOptionIndexT = 0;
        let productOptionsIndex = 1;

        if ($("body").hasClass("custom-bundle")) {
          item
            .find(".ColorSwatchList")
            .children(".HorizontalList__Item")
            .each(function () {
              productOptionIndexT += 1;
              var productOptionIndexValue = "option-" + productNumber + "-" + productOptionsIndex;
              var productOptionIndexId =
                "option-product-custom-bundle-template-" +
                productNumber +
                "-" +
                productOptionIndexT;

              $(this).find(".ColorSwatch__Radio").attr("name", productOptionIndexValue);
              $(this).find(".ColorSwatch__Radio").attr("id", productOptionIndexId);
              $(this).find("label").attr("for", productOptionIndexId);
            });
          productOptionsIndex += 1;
          item
            .find(".SizeSwatchList")
            .children(".HorizontalList__Item")
            .each(function () {
              productOptionIndexT += 1;
              var productOptionIndexValue = "option-" + productNumber + "-" + productOptionsIndex;
              var productOptionIndexId =
                "option-product-custom-bundle-template-" +
                productNumber +
                "-" +
                productOptionIndexT;

              $(this).find(".SizeSwatch__Radio").attr("name", productOptionIndexValue);
              $(this).find(".SizeSwatch__Radio").attr("id", productOptionIndexId);
              $(this).find("label").attr("for", productOptionIndexId);
            });
        }
      },

      // define a function for spawning extra items
      spawnItem() {
        let item = $(".custom-bundle-form-item:last").clone();
        item.find("[id=map]").remove();
        item.find("[id=geocoder]").remove();
        item.removeClass("open-product");
        $(".custom-bundle-products-container").append(item);
        customBundle.markInitialSearchReady(item, false);
        customBundle.addEventListeners(item);
        customBundle.applyDataAttributes(item);
        customBundle.toggleStateCustomized(item, false);
        customBundle.renderProperties(item);

        let productIndex = item.attr("data-product-index");
        localStorage.setItem(
          productIndex + "-" + "cuffCoordinatesLongitude",
          defaultCoordinates.longtitude
        );
        localStorage.setItem(
          productIndex + "-" + "cuffCoordinatesLatitude",
          defaultCoordinates.latitude
        );

        morseCode.init();
        customSwitcherBox.initEngravingFontChooser();
        customSwitcherBox.initButtons();

        customBundle.updateCloneButtonText();
        return item;
      },

      // define a function to initialize custom-bundle related stuff
      init({ extraItemCount }) {
        // prepare the first item
        let item = $(".custom-bundle-form-item:first");
        customBundle.addEventListeners(item);
        customBundle.applyDataAttributes(item);
        customBundle.toggleStateCustomized(item, false);

        // spawn one extra item
        for (let i = 0; i < extraItemCount; i++) {
          customBundle.spawnItem();
        }

        // the clone button can be used to spawn more items
        $("button#Product__Clone").click(function () {
          let newItem = customBundle.spawnItem();
          newItem.find(".bundle-form-item-label").trigger("click");
          $("html, body").animate({ scrollTop: newItem.offset().top - 60 }, 500);
        });
        $("button#Product__Clone").attr("disabled", false);
        $(".custom-bundle-form-item .bundle-form-item-label").attr("disabled", false);
      },

      updateCloneButtonText() {
        let count = $(".custom-bundle-form-item").length;
        $("button#Product__Clone .bundle-next-index").html(customBundle._getOrdinal(count + 1));
      },

      _getOrdinal(n) {
        let ord = ["st", "nd", "rd"];
        let exceptions = [11, 12, 13];
        let nth =
          ord[(n % 10) - 1] == undefined || exceptions.includes(n % 100) ? "th" : ord[(n % 10) - 1];
        return n + nth;
      },
    };

    $(".bundle-initiate").click(function () {
      console.log("bundle-add-to-triggered");
      $(".bundle-deactivated").removeClass("bundle-deactivated");
      $(this).removeClass("bundle-addto");
      $("body").addClass("custom-bundle");
    });

    //$(".engravingArea").appendTo(".product-main-images");
    //$(".engravingArea").addClass("mobile-engraving");
    /*mapActions();
        $(".sspecial-group-hide").hide();*/
    var map = undefined;
    var geocoder = undefined;

    customSwitcherBox.initEngravingFontChooser();

    if ($("body").hasClass("custom-bundle")) {
      // actually initialize custom-bundle items!
      customBundle.init({ extraItemCount: 1 });
    } else if ($("body").hasClass("custom-cuff")) {
      customBundle.init({ extraItemCount: 0 });
    }

    document.addEventListener("variant:changed", function (event) {
      var variant = event.detail.variant; // Gives you access to the whole variant details
    });

    $("body").on("click", ".checkout-atc", function (e) {
      var freeGiftItemID = $(this).closest(".checkout-upsell-item").data("variant-id");

      var params = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + 1 + "&id=" + freeGiftItemID,
        dataType: "json",
        success: function () {
          if (typeof callback === "function") {
            callback(cart);
          } else {
            ShopifyAPI.getCart(cartUpdateCallback);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            ShopifyAPI.onError(XMLHttpRequest, textStatus);
          }
        },
      };
      jQuery.ajax(params);
    });
    $(".upsell-swatch-list-item").on("change", function () {
      var pro_id = $(this).data("id");
      var tootltip = $(this).find("label").data("tooltip");
      // console.log(pro_id+' option');
      $("#" + pro_id + " option").removeAttr("selected");
      $("#" + pro_id + " option").each(function () {
        var var_title = $(this).data("title");
        var var_val = $(this).attr("value");

        if (var_title == tootltip) {
          $(this).attr("selected", "selected");
          //alert(var_title +'--'+ tootltip + '-'+ var_val);
          $('.product-upsell-item--variants[data-id="' + pro_id + '"]').attr(
            "data-variant-id",
            var_val
          );
        }
      });
    });

    $(".upsell-swatch-list-item").click(function () {
      var pro_id = $(this).data("id");
      var tootltip = $(this).find("label").data("tooltip");
      // console.log(pro_id+' option');
      $("#" + pro_id + " option").removeAttr("selected");
      $("#" + pro_id + " option").each(function () {
        var var_title = $(this).data("title");
        var var_val = $(this).attr("value");

        if (var_title == tootltip) {
          $(this).attr("selected", "selected");
          //alert(var_title +'--'+ tootltip + '-'+ var_val);
          $('.product-upsell-item--variants[data-id="' + pro_id + '"]').attr(
            "data-variant-id",
            var_val
          );
        }
      });
      var selectedOptionPrice = $(this).closest(".product-upsell-item").data("variant-price");
      var selectedOptionPriceCompare = $(this)
        .closest(".product-upsell-item")
        .data("variant-price-compare");

      var parentSwatchItemElem = $(this).closest(".product-upsell-item");
      var currentOptionList = $(this).closest(".upsell-swatch-list");
      currentOptionList.find(".upsell-swatch-list-item").removeClass("selectedUpsell-color-item");

      $(this).addClass("selectedUpsell-color-item");
      var currentVariantId = parentSwatchItemElem
        .find(".selectedUpsell-color-item")
        .data("variant-id");
      console.log("currentVariantId", currentVariantId);
      console.log("price", selectedOptionPrice);
      console.log("price", selectedOptionPriceCompare);
      parentSwatchItemElem
        .find(".product-upsell-item--variants")
        .attr("data-variant-id", currentVariantId);
      // parentSwatchItemElem.find(".product-upsell-item--price span").html(selectedOptionPrice);
      GIP.forceUpdate();
    });

    customSwitcherBox.initVariables();

    $(".landing-product-item").click(function () {
      var landingProdItemId = $(this).data("product-id");
      var landingVarItemId = $(this).data("variant-id");

      if (!$(this).hasClass("selected-landing-product-item")) {
        $(".landing-product-item").removeClass("selected-landing-product-item");
        $(this).addClass("selected-landing-product-item");

        var landingSelectedProdIndex = $(".selected-landing-product-item").data("productindex");

        $(".landing-productItem-form").removeClass("selected-landingForm");
        $(".landing-productItem-form[data-formindex=" + landingSelectedProdIndex + "]").addClass(
          "selected-landingForm"
        );
        map.remove();
        $("[id=map]").remove();
        $("[id=geocoder]").remove();
        $("[data-section-id=custom-landing-form] .ProductForm__AddToCart").removeClass(
          "ProductForm__AddToCart"
        );
        $(".selected-landingForm .mapContainer").append('<div id="map"></div>');
        $(".selected-landingForm #search").prepend('<div id="geocoder"></div>');
        $(".selected-landingForm #Product__AddToCart").addClass("ProductForm__AddToCart");
        mapView();
        (function () {
          var longForConvert = parseFloat(localStorage.getItem("cuffCoordinatesLongitude"));
          var latForConvert = parseFloat(localStorage.getItem("cuffCoordinatesLatitude"));

          geocoder.setLimit(1);
          geocoder.query("" + longForConvert + ", " + latForConvert + "");
          $(".selected-landingForm #map").css("pointer-events", "none");

          map.once("moveend", function (e) {
            $(".mapboxgl-ctrl-geocoder--input").val("Your special place...");
            geocoder.setLimit(5);
          });
        })();
        $(".landing-product-gallery-wrapper").removeClass("selected-product-gallery");
        $(".landing-product-gallery-wrapper[data-product-id=" + landingProdItemId + "]").addClass(
          "selected-product-gallery"
        );
      }
    });

    // TODO: this piece of code (.addEng-option--YES/NO) should be moved to customSwitcherBox in custom.js as well.

    $(".addEng-option--YES").click(function () {
      $(".enable-engrave-hide").show();
      $(".addEng-option--NO").removeClass("engSelected");
      $(this).addClass("engSelected");
      $(".enable-engrave-hide .maps-latitude input").attr("name", "properties[Latitude]");
      $(".enable-engrave-hide .maps-longitude input").attr("name", "properties[Longitude]");
      $("#engraving-font").attr("name", "properties[Font]");
      $(".special-group-hide").removeClass("special-map-hide");
      $(".special-group-hide").show();
      $(".special-input").show();
      $(".maps-input-label").show();
      $(".special-group-display").show();
      if ($(".input-container-switch").children().length == 0) {
        let cuffCoordinatesLatitude = localStorage
          .getItem("cuffCoordinatesLatitude")
          .replace('"', "&quot;");
        let cuffCoordinatesLongitude = localStorage
          .getItem("cuffCoordinatesLongitude")
          .replace('"', "&quot;");
        $(".input-container-switch").append(
          '<div class="line-item-property__field maps-latitude"><input id="latitude" maxlength="14" type="text" name="properties[Latitude]" value="' +
            cuffCoordinatesLatitude +
            '"></div><div class="line-item-property__field maps-longitude"><input id="longtitude" maxlength="14" type="text" name="properties[Longitude]" value="' +
            cuffCoordinatesLongitude +
            '"></div>'
        );
        $(".text-engrave").remove();
        $(".text-engrave-left").remove();
      }
    });
    $(".addEng-option--NO").click(function () {
      $(".enable-engrave-hide").hide();
      $(".addEng-option--YES").removeClass("engSelected");
      $(this).addClass("engSelected");
      $(".enable-engrave-hide .maps-latitude input").attr("name", "");
      $(".enable-engrave-hide .maps-longitude input").attr("name", "");
      $("#engraving-font").attr("name", "");
      $(".special-group-hide").addClass("special-map-hide");
      $(".custom-switcher-btn").removeClass("active-switcher");
      $(".engrave-text-switch-cont").hide();
      $(".engrave-text-cont").hide();
      $(".coords-btn").addClass("active-switcher");
    });

    customSwitcherBox.initButtons();

    $(".mapboxgl-ctrl-geocoder").remove();
    $(this).removeClass("firstCoordInputView");
    $(this).addClass("mapView");

    mapView();
    $(".special-group-hide").show();
    $(".toggle").show();
    $(".toggleMapView").click(function () {
      if ($(this).hasClass("firstCoordInputView")) {
        $(".mapboxgl-ctrl-geocoder").remove();
        $(this).removeClass("firstCoordInputView");
        $(this).addClass("mapView");
        $(".special-group-hide").addClass("mapViewOn");
        mapView();
        $(".special-group-hide").show();
        $(".toggle").show();
      } else if ($(this).hasClass("mapView")) {
        $(".special-group-hide").removeClass("mapViewOn");
        $(this).removeClass("mapView");
        $(this).addClass("coordInputView");
      } else if ($(this).hasClass("coordInputView")) {
        $(this).removeClass("coordInputView");
        $(this).addClass("mapView");
        $(".special-group-hide").addClass("mapViewOn");
        $(".toggle").show();
      }
    });

    function waitForMapboxgl(trigger) {
      var interval = setInterval(function () {
        if (typeof mapboxgl !== "undefined") {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    function mapView() {
      waitForMapboxgl(function () {
        let localStorageKeyPrefix = mapGetLocalStorageKeyPrefix();
        var longForConvert = parseFloat(
          localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLongitude")
        );
        var latForConvert = parseFloat(
          localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLatitude")
        );

        mapboxgl.accessToken =
          "pk.eyJ1IjoiY3VzdG9tY3VmZiIsImEiOiJja2FrczA0cXAwbmM2MnR0ZGR1dnljdGx0In0._EkFqlWTPsGRXyxeRebiYg";
        map = new mapboxgl.Map({
          container: "map",
          style: "mapbox://styles/customcuff/ck6j63f0e10w11inyc4c8za4k?optimize=true",
          center: [longForConvert, latForConvert],
          zoom: 13,
        });
        const geolocate = new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        });

        map.addControl(geolocate);
        var coordinatesGeocoder = function (query) {
          // match anything which looks like a decimal degrees coordinate pair
          var matches = query.match(
            /^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
          );
          if (!matches) {
            return null;
          }

          function coordinateFeature(lng, lat) {
            return {
              center: [lng, lat],
              geometry: {
                type: "Point",
                coordinates: [lng, lat],
              },
              place_name: "" + lat + ", " + lng,
              place_type: ["coordinate"],
              properties: {},
              type: "Feature",
            };
          }

          var coord1 = Number(matches[1]);
          var coord2 = Number(matches[2]);
          var geocodes = [];

          if (coord1 < -90 || coord1 > 90) {
            // must be lng, lat
            geocodes.push(coordinateFeature(coord1, coord2));
          }

          if (coord2 < -90 || coord2 > 90) {
            // must be lat, lng
            geocodes.push(coordinateFeature(coord2, coord1));
          }

          if (geocodes.length === 0) {
            // else could be either lng, lat or lat, lng
            geocodes.push(coordinateFeature(coord1, coord2));
            geocodes.push(coordinateFeature(coord2, coord1));
          }

          return geocodes;
        };
        map.on("load", function () {
          let localStorageKeyPrefix = mapGetLocalStorageKeyPrefix();
          var longForConvert = parseFloat(
            localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLongitude")
          );
          var latForConvert = parseFloat(
            localStorage.getItem(localStorageKeyPrefix + "cuffCoordinatesLatitude")
          );

          geocoder.setLimit(1);
          geocoder.query("" + longForConvert + ", " + latForConvert + "");
          $("[id=map]").css("pointer-events", "none");

          map.once("moveend", function (e) {
            $(".mapboxgl-ctrl-geocoder--input").val("Your special place...");
            geocoder.setLimit(5);
          });
        });

        geolocate.on("geolocate", function () {
          //Get the updated user location, this returns a javascript object.
          var userlocation = geolocate._lastKnownPosition;

          var lat = userlocation.coords.latitude;
          var lng = userlocation.coords.longitude;
          updateCoordinateInputs(lat, lng);
        });

        function findLocation() {
          document.querySelector(".mapboxgl-ctrl-geocoder--input").id = "mapbox-search";
          document.querySelector(".suggestions").id = "suggestionsBox";
          geocoder.query(document.getElementById("mapbox-search").value);
          document.getElementById("suggestionsBox").style.display = "none";
        }
        $("#findLocationBtn").click(findLocation);

        var checkbox = map
          .getContainer()
          .parentElement.parentElement.querySelector("[id=map-lock-input]");

        checkbox.addEventListener("change", function () {
          if (this.checked) {
            $("[id=map]").css("pointer-events", "auto");
          } else {
            $("[id=map]").css("pointer-events", "none");
          }
        });

        /* given a query in the form "lng, lat" or "lat, lng" returns the matching
         * geographic coordinate(s) as search results in carmen geojson format,
         * https://github.com/mapbox/carmen/blob/master/carmen-geojson.md
         */

        geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mode: "mapbox.places-permanent", // does not provide POI data
          localGeocoder: coordinatesGeocoder,
          zoom: 7,
          mapboxgl: mapboxgl,
          flyTo: {
            duration: 0,
          },
        });

        geocoder.on("result", function (ev, curve) {
          var latString = ev.result.geometry.coordinates[1];
          var lngString = ev.result.geometry.coordinates[0];
          $(".mapboxgl-ctrl-geocoder--input").blur();

          var lat = JSON.stringify(latString);
          var lng = JSON.stringify(lngString);
          updateCoordinateInputs(lat, lng);

          let item = $(map.getContainer()).closest(".custom-bundle-form-item");
          if (!customBundle.isInitialSearchReady(item)) {
            customBundle.markInitialSearchReady(item, true);
          } else {
            customBundle.onItemChange(item);
          }
        });

        map.on("click", function (e) {
          var lat = JSON.stringify(e.lngLat.lat);
          var lng = JSON.stringify(e.lngLat.lng);
          if (geocoder.mapMarker) {
            geocoder.mapMarker.setLngLat(e.lngLat);
            updateCoordinateInputs(lat, lng);
          } else {
            var marker = new mapboxgl.Marker().setLngLat(e.lngLat).addTo(map);
            geocoder.mapMarker = marker;
            updateCoordinateInputs(lat, lng);
          }
        });

        map.addControl(new mapboxgl.NavigationControl());
        document.getElementById("geocoder").appendChild(geocoder.onAdd(map));

        $(".mapboxgl-ctrl-geocoder--input").on("click", function () {
          geocoder.clear();
          //$(".mapboxgl-ctrl-geocoder--input").attr('placeholder', '');
        });
        $(".mapboxgl-ctrl-geocoder--input").on("click", function () {
          $(".special-group-hide").addClass("mapViewOn");
        });
        $(".mapboxgl-ctrl-geocoder--suggestion").on("click", function () {
          $(".special-group-hide").addClass("mapViewOn");
        });
      });
    }

    $(".open-product [id=dmstoggler]").on("change", function (eventInfo) {
      let longInput = $(eventInfo.target).closest("form").find("#longtitude").get();
      let latInput = $(eventInfo.target).closest("form").find("#latitude").get();

      if (eventInfo.target.checked) {
        // convert to DMS
        let dms = convertDDToDMS(latInput.value, longInput.value);
        latInput.value = dms.latitude;
        longInput.value = dms.longtitude;
        //localStorage.setItem("cuffCoordinatesLongitude", dms.longtitude);
        //localStorage.setItem("cuffCoordinatesLatitude", dms.latitude);
      } else {
        // convert back to decimal degrees
        let dd = convertDMSToDD(latInput.value, longInput.value);
        latInput.value = dd.latitude;
        longInput.value = dd.longtitude;
        //localStorage.setItem("cuffCoordinatesLongitude", dd.longtitude);
        //localStorage.setItem("cuffCoordinatesLatitude", dd.latitude);
      }
      $("[id=dmstoggler_state]").html(eventInfo.target.checked ? "DMS" : "Decimal degrees");
    });
  });

  function startIt(productImage) {
    let canvasDiv = document.getElementById("canvasDiv");
    //canvasDiv.innerHTML = '<canvas id="layer0" width="' + productImage.naturalWidth + '" height="' + productImage.naturalHeight + '"></canvas>'; //for IE
    if ($(".Product__Gallery").hasClass("engrave-charm")) {
      canvasDiv.innerHTML = '<canvas id="layer0" width="800" height="800"></canvas>';
    } else {
      canvasDiv.innerHTML = '<canvas id="layer0" width="1000" height="1000"></canvas>';
    }
    //for IE
    product_custom_cuff.canvas = document.getElementById("layer0");
    product_custom_cuff.ctx = product_custom_cuff.canvas.getContext("2d");
    product_custom_cuff.ctx.fillStyle = "#000";
    //product_custom_cuff.curve = "50,228,100,260,270,260,330,240";// <-- only work with canvas 400x400
    if ($(".Product__Gallery").hasClass("engrave-charm")) {
      product_custom_cuff.curve = [400, 490, 400, 550, 400, 600, 400, 680];
    } else {
      product_custom_cuff.curve = [150, 590, 325, 650, 650, 650, 825, 600];
    }

    // <-- only work with canvas 1000x1000

    // this code can be used to calc new numbers, if you resize the canvas
    /*let canvasSize = parseInt($('#layer0').attr('width'));// width and height is assumed to be the same
  product_custom_cuff.curve = product_custom_cuff.curve.map(num => {
    return (canvasSize/400) * num
  });
  console.log(product_custom_cuff.curve)
  */

    product_custom_cuff.scale = 1; //productImage.naturalWidth / 400;

    //$(curveOffset).on('change', changeCurve);
    //$(fontSize).on('change', changeCurve);

    if (product_custom_cuff.first) {
      changeCurve(product_custom_cuff.ctx, product_custom_cuff.curve);
      product_custom_cuff.first = false;
    }
  }
  function changeCurve(ctx, curve, curveOffset, curveOffsetX, fontSize = 36) {
    if ($(".product-main-images").hasClass("engrave-chain")) {
      curveOffset = -216;
      curveOffsetX = -30;
    } else if ($(".product-main-images").hasClass("engrave-necklace")) {
      curveOffset = 12;
      curveOffsetX = 2;
    } else {
      curveOffset = 16;
      curveOffsetX = 0;
    }
    product_custom_cuff.points = curve;
    product_custom_cuff.offset = parseInt(curveOffset) || 0;
    product_custom_cuff.offsetX = parseInt(curveOffsetX) || 0;
    product_custom_cuff.fontSize = fontSize;

    if (product_custom_cuff.points.length == 8) {
      drawStack();
    }
  }

  function drawStack() {
    let { scale, canvas, ctx, curveText, points, offset, offsetX } = product_custom_cuff;

    Ribbon = {
      maxChar: 50,
      startX: (points[0] - offsetX) * scale,
      startY: (points[1] - offset) * scale,
      control1X: (points[2] - offsetX) * scale,
      control1Y: (points[3] - offset) * scale,
      control2X: (points[4] - offsetX) * scale,
      control2Y: (points[5] - offset) * scale,
      endX: (points[6] - offsetX) * scale,
      endY: (points[7] - offset) * scale,
    };

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.beginPath();

    ctx.moveTo(Ribbon.startX, Ribbon.startY);
    ctx.bezierCurveTo(
      Ribbon.control1X,
      Ribbon.control1Y,
      Ribbon.control2X,
      Ribbon.control2Y,
      Ribbon.endX,
      Ribbon.endY
    );

    //ctx.stroke();
    ctx.restore();
    var mobVariantImgId = $(".slick-current .product-variant-image").data("image-id");
    var deskVariantImgId = $(".product-variant-image.selected").data("image-id");
    var mattColorImgIds = [
      16640780828733, 16643170762813, 16643167715389, 16643110273085, 16643110633533,
      16642393833533, 16643086024765, 16642403401789, 16643086057533,
    ];

    console.log("Desktop img id", deskVariantImgId);
    console.log("Matt color img ids", mattColorImgIds);
    console.log(mattColorImgIds.indexOf(deskVariantImgId) > -1);
    if (mobVariantImgId == "16643167813693" || deskVariantImgId == "16643167813693") {
      product_custom_cuff.ctx.fillStyle = "#8b8b8b";
      console.log("This is a Black cuff");
    } else if (mobVariantImgId == "16643110305853" || deskVariantImgId == "16643110305853") {
      product_custom_cuff.ctx.fillStyle = "#8b8b8b";
      console.log("This is a black necklace");
    } else if (
      mattColorImgIds.indexOf(mobVariantImgId) > -1 ||
      mattColorImgIds.indexOf(deskVariantImgId) > -1
    ) {
      console.log("This is a normal cuff");
      product_custom_cuff.ctx.fillStyle = "#626262";
    } else {
      console.log("This is a normal cuff");
      product_custom_cuff.ctx.fillStyle = "#000";
    }

    if ($(".Product__Gallery").hasClass("engrave-charm")) {
      product_custom_cuff.fontSize = 14;
      product_custom_cuff.offset = 8;
      product_custom_cuff.offsetX = 2;
    } else if ($(".Product__Gallery").hasClass("engrave-chain")) {
      product_custom_cuff.fontSize = 24;
      product_custom_cuff.offset = -216;
      product_custom_cuff.offsetX = -30;
    }
    if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-handwriter")) {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Engraving Handwriting";
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-standard")) {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Engraving Standard";
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-oldLondon")) {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Engraving Old London";
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-typewriter")) {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Engraving Typewriter";
    } else {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Courier New";
    }

    if (document.querySelector(".Product__Gallery").classList.contains("coords-engraving")) {
      console.log(true);
      let curveCoordsOne = document.getElementById("latitude").value;
      let curveCoordsTwo = document.getElementById("longtitude").value;
      let curveCoords = curveCoordsOne + "  " + curveCoordsTwo;
      FillRibbon(curveCoords, Ribbon);
    } else {
      FillRibbon(curveText.value, Ribbon);
      console.log(false);
    }
  }
  function FillRibbon(text, Ribbon) {
    let ctx = product_custom_cuff.ctx;

    var textCurve = [];
    var ribbon = text.substring(0, Ribbon.maxChar);
    var curveSample = 1000;

    xDist = 0;
    var i = 0;
    for (i = 0; i < curveSample; i++) {
      a = new bezier2(
        i / curveSample,
        Ribbon.startX,
        Ribbon.startY,
        Ribbon.control1X,
        Ribbon.control1Y,
        Ribbon.control2X,
        Ribbon.control2Y,
        Ribbon.endX,
        Ribbon.endY
      );
      b = new bezier2(
        (i + 1) / curveSample,
        Ribbon.startX,
        Ribbon.startY,
        Ribbon.control1X,
        Ribbon.control1Y,
        Ribbon.control2X,
        Ribbon.control2Y,
        Ribbon.endX,
        Ribbon.endY
      );
      c = new bezier(a, b);
      textCurve.push({
        bezier: a,
        curve: c.curve,
      });
    }
    /* if ($().hasClass("engrave-chain")){
    letterPadding = ctx.measureText("").width / 2; 
    
  } else {
    
  }*/
    if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-handwriter")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-standard")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-oldLondon")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else if ($(".engrave-font-chooser-item.font-selected").hasClass("font-chooser-typewriter")) {
      letterPadding = ctx.measureText(" ").width / 4;
    } else {
      ctx.font =
        "600 " +
        parseInt(product_custom_cuff.fontSize) * product_custom_cuff.scale +
        "px Courier New";
      letterPadding = ctx.measureText(" ").width / -6;
    }

    w = ribbon.length;
    ww = Math.round(ctx.measureText(ribbon).width);

    totalPadding = (w - 1) * letterPadding;
    totalLength = ww + totalPadding;
    p = 0;

    cDist = textCurve[curveSample - 1].curve.cDist;

    z = cDist / 2 - totalLength / 2;

    for (i = 0; i < curveSample; i++) {
      if (textCurve[i].curve.cDist >= z) {
        p = i;
        break;
      }
    }

    for (i = 0; i < w; i++) {
      ctx.save();
      ctx.translate(textCurve[p].bezier.point.x, textCurve[p].bezier.point.y);
      ctx.rotate(textCurve[p].curve.rad);
      ctx.fillText(ribbon[i], 0, 0);
      ctx.restore();

      x1 = ctx.measureText(ribbon[i]).width + letterPadding;
      x2 = 0;
      for (j = p; j < curveSample; j++) {
        x2 = x2 + textCurve[j].curve.dist;
        if (x2 >= x1) {
          p = j;
          break;
        }
      }
    }
  } //end FillRibon

  function bezier(b1, b2) {
    //Final stage which takes p, p+1 and calculates the rotation, distance on the path and accumulates the total distance
    this.rad = Math.atan(b1.point.mY / b1.point.mX);
    this.b2 = b2;
    this.b1 = b1;
    dx = b2.x - b1.x;
    dx2 = (b2.x - b1.x) * (b2.x - b1.x);
    this.dist = Math.sqrt((b2.x - b1.x) * (b2.x - b1.x) + (b2.y - b1.y) * (b2.y - b1.y));
    xDist = xDist + this.dist;
    this.curve = {
      rad: this.rad,
      dist: this.dist,
      cDist: xDist,
    };
  }

  function bezierT(t, startX, startY, control1X, control1Y, control2X, control2Y, endX, endY) {
    //calculates the tangent line to a point in the curve; later used to calculate the degrees of rotation at this point.
    this.mx =
      3 * (1 - t) * (1 - t) * (control1X - startX) +
      6 * (1 - t) * t * (control2X - control1X) +
      3 * t * t * (endX - control2X);
    this.my =
      3 * (1 - t) * (1 - t) * (control1Y - startY) +
      6 * (1 - t) * t * (control2Y - control1Y) +
      3 * t * t * (endY - control2Y);
  }

  function bezier2(t, startX, startY, control1X, control1Y, control2X, control2Y, endX, endY) {
    //Quadratic bezier curve plotter
    this.Bezier1 = new bezier1(t, startX, startY, control1X, control1Y, control2X, control2Y);
    this.Bezier2 = new bezier1(t, control1X, control1Y, control2X, control2Y, endX, endY);
    this.x = (1 - t) * this.Bezier1.x + t * this.Bezier2.x;
    this.y = (1 - t) * this.Bezier1.y + t * this.Bezier2.y;
    this.slope = new bezierT(
      t,
      startX,
      startY,
      control1X,
      control1Y,
      control2X,
      control2Y,
      endX,
      endY
    );

    this.point = {
      t: t,
      x: this.x,
      y: this.y,
      mX: this.slope.mx,
      mY: this.slope.my,
    };
  }

  function bezier1(t, startX, startY, control1X, control1Y, control2X, control2Y) {
    //linear bezier curve plotter; used recursivly in the quadratic bezier curve calculation
    this.x = (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * control1X + t * t * control2X;
    this.y = (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * control1Y + t * t * control2Y;
  }
}, __app_timeout);
